import { useLayoutEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to the top whenever the route (pathname) changes.
 * Hash-only changes (e.g. #pricing) are ignored so in-page anchor links
 * still scroll to their target.
 *
 * The very first run is skipped: that one is a page load, not a navigation,
 * and resetting there threw away the browser's own scroll restoration — every
 * refresh bounced the reader back to the top of the page.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  const isFirstRun = useRef(true);

  useLayoutEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    // `html, body { overflow-x: hidden }` + `height: 100%` makes <body> itself the
    // scroll container, so window.scrollTo alone is a no-op — reset every candidate.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  return null;
};

export default ScrollToTop;
